import { render, staticRenderFns } from "./toDeletedList.vue?vue&type=template&id=02cb0210&scoped=true"
import script from "./toDeletedList.vue?vue&type=script&lang=ts"
export * from "./toDeletedList.vue?vue&type=script&lang=ts"
import style0 from "./toDeletedList.vue?vue&type=style&index=0&id=02cb0210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb0210",
  null
  
)

export default component.exports